import React from 'react';

// Month order for fiscal year (April → March)
const MONTH_ORDER = [
  'APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER',
  'OCTOBER','NOVEMBER','DECEMBER','JANUARY','FEBRUARY','MARCH'
];

const MONTH_SHORT = {
  APRIL:'Apr', MAY:'May', JUNE:'Jun', JULY:'Jul',
  AUGUST:'Aug', SEPTEMBER:'Sep', OCTOBER:'Oct', NOVEMBER:'Nov',
  DECEMBER:'Dec', JANUARY:'Jan', FEBRUARY:'Feb', MARCH:'Mar'
};

function fmt(n) {
  if (!n && n !== 0) return '₹0';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 10000000) return `${sign}₹${(abs/10000000).toFixed(2)} Cr`;
  if (abs >= 100000)   return `${sign}₹${(abs/100000).toFixed(1)} L`;
  if (abs >= 1000)     return `${sign}₹${(abs/1000).toFixed(1)} K`;
  return `${sign}₹${Number(abs).toLocaleString('en-IN')}`;
}

export default function MonthlyChart({ returns }) {
  if (!returns || returns.length === 0) return (
    <div style={{ padding:16, height:280, boxSizing:'border-box', overflowY:'auto' }}>
      <div style={{ fontSize:10, fontWeight:600, color:'#888', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:10 }}>
        Monthly Performance
      </div>
      <div style={{ fontSize:12, color:'#aaa', textAlign:'center', padding:20 }}>No monthly data yet</div>
    </div>
  );

  // Sort by fiscal year month order — handles dynamic months automatically
  const sorted = [...returns].sort((a, b) => {
    const ai = MONTH_ORDER.indexOf(a.month.toUpperCase());
    const bi = MONTH_ORDER.indexOf(b.month.toUpperCase());
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });

  const maxAbs = Math.max(...sorted.map(r => Math.abs(r.profit)), 1);

  return (
    <div style={{ background:'#fff', border:'1px solid #f0e8e5', borderRadius:10, padding:'14px 16px', marginBottom:16 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
        <div style={{ fontSize:10, fontWeight:600, color:'#888', textTransform:'uppercase', letterSpacing:'0.08em' }}>
          Monthly Performance
        </div>
        <div style={{ fontSize:10, color:'#888' }}>
          Total: {fmt(sorted.reduce((a,r) => a + r.profit, 0))}
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {sorted.map(r => {
          const pct    = Math.abs(r.profit) / maxAbs * 100;
          const positive = r.profit >= 0;
          return (
            <div key={r.month} style={{ display:'flex', alignItems:'center', gap:10 }}>
              {/* Month label */}
              <div style={{ width:30, fontSize:11, color:'#666', fontWeight:500, flexShrink:0, textAlign:'right' }}>
                {MONTH_SHORT[r.month.toUpperCase()] || r.month.slice(0,3)}
              </div>
              {/* Bar track */}
              <div style={{ flex:1, height:20, background:'#f5f0ee', borderRadius:4, overflow:'hidden', position:'relative' }}>
                <div style={{
                  position:'absolute', left:0, top:0, bottom:0,
                  width:`${pct}%`,
                  background: positive ? '#6B1C2A' : '#e74c3c',
                  borderRadius:4,
                  transition:'width 0.6s ease',
                }} />
              </div>
              {/* Value */}
              <div style={{
                width:70, fontSize:11, textAlign:'right', flexShrink:0,
                color: positive ? '#6B1C2A' : '#e74c3c',
                fontWeight:600,
              }}>
                {fmt(r.profit)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
